module.exports = (code) ->
    for own n, it of error
        if it.code == code
            return it
    throw new Error('Unknown code: ' + code)

error = require('./error').default



// WEBPACK FOOTER //
// ./app/jsmodel/error.byCode.coffee